// @flow
import { makeGetRequest } from '../../utils'

import type { Country } from '../../types/countries'
import type { ResponseAPI } from '../../types/api'

export const getTvShowCountries = (domain: string, serviceId: string): Promise<ResponseAPI<Array<Country>>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceId}/tv-show/countries`)
